/**
 * Converts a 1-based Excel column number to its letter representation.
 * Examples:
 *  1  -> A
 *  26 -> Z
 *  27 -> AA
 *  28 -> AB
 */
export function columnNumberToExcelLetter(column: number): string {
  if (column <= 0) {
    throw new Error("Excel column number must be greater than zero");
  }

  let result = "";
  let current = column;

  while (current > 0) {
    current--; // Excel is 1-based
    const remainder = current % 26;
    result = String.fromCharCode(65 + remainder) + result;
    current = Math.floor(current / 26);
  }

  return result;
}
